<template>
  <elementToRender />
</template>

<script lang="ts" setup>
import { h } from 'vue'

interface Props {
  fullText: string
  textToHighlight: string
}

const props = defineProps<Props>()

const ALPHABET_ACCENTS = {
  a: '[aàáâãäåÀÁÂÃÄÅæÆ]',
  b: '[bß]',
  c: '[cçÇ]',
  d: '[dÐð]',
  e: '[eèéêëÈÉÊËæ]',
  i: '[iìíîïÌÍÎÏ]',
  n: '[nñ]',
  o: '[oòóôõöøÒÓÔÕÖØœŒð]',
  s: '[sß]',
  u: '[uùúûüÙÚÛÜ]',
  y: '[yýÿÝŸ]',
  // Two letter accents: match 'a' + 'e' and all its accents OR 'æ'
  ae: '([aàáâãäåÀÁÂÃÄÅ][eèéêëÈÉÊË]|[æÆ])',
  oe: '([oòóôõöøÒÓÔÕÖØð][eèéêëÈÉÊË]|[œŒ])',
  ce: '([cçÇ][eèéêëÈÉÊË]|[œŒ])',
}

const createRegexpStr = (text: string): string => {
  return (
    text
      ?.trim()
      // To match special characters
      .replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&')
      // To allow multi-word matches with whitespace
      .replace(/\s/g, '|')
      // To match letter accents and allow exclusion of single quotes
      .replace(/ae|oe|ce|[a-z]/gi, match => {
        const accent =
          ALPHABET_ACCENTS[match.toLowerCase() as keyof typeof ALPHABET_ACCENTS]
        return accent ? `'?${accent}` : `'?${match}`
      })
  )
}

const resolveContent = (): string => {
  const regexpStr = createRegexpStr(props.textToHighlight)

  if (regexpStr) {
    return props.fullText.replace(new RegExp(regexpStr, 'gi'), match => {
      return `<span style="color: var(--color-base-red-100);">${match}</span>`
    })
  } else return props.fullText
}

const elementToRender = () => {
  return h('p', {
    innerHTML: resolveContent(),
  })
}
</script>
